// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const ApprovalKendaraanPage = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    Tanggal: new Date(),
    PurchaseOrderID: "",
    KendaraanID: "CS001",
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };
  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const param = useLocation();
  const params = useParams();

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData)
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/Kendaraan", formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Procurement/Kendaraan/byId/" + formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/Kendaraan/approval", formData)
  );
  const po = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/min/" + formData)
  );
  const detailPO = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/warehouse/" + formData)
  );

  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail(detail);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    let newDetail = [...detail];
    newDetail.splice(id, 1);
    setDetail(newDetail);
  };

  const navigate = useNavigate();

  useEffect(() => {
    barang.mutate();
    if (params.id) {
      mutationGet.mutate(params.id);
    }
  }, []);

  useEffect(() => {
    po.mutate(values.BisnisUnitID);
  }, [values.BisnisUnitID]);

  useEffect(() => {
    detailPO.mutate(values.PurchaseOrderID);
  }, [values.PurchaseOrderID]);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate("/equipment/kendaraan");
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationAdd) {
      if (mutationAdd.isSuccess) {
        navigate("/equipment/kendaraan");
      }
    }
  }, [mutationAdd.status]);

  useEffect(() => {
    if (mutationGet.data) {
      let temp = mutationGet.data.data;

      setDetail(temp["Data"]);
      blastChange(mutationGet.data.data);
    }
  }, [mutationGet.status]);

  const header = [
    { name: "Nik", key: "Nik", modifiers: "Barang" },
    { name: "Activity", key: "ActivityID", modifiers: "BarangSatuan" },
    { name: "Hasil Kerja", key: "HasilKerja", modifiers: "text" },
    { name: "Satuan", key: "Satuan", modifiers: "text" },
    { name: "Jam Awal", key: "JamAwal", modifiers: "text" },
    { name: "Jam Akhir", key: "JamAkhir", modifiers: "text" },
    { name: "KMHM Awal", key: "KMHMAwal", modifiers: "text" },
    { name: "KMHM Akhir", key: "KMHMAkhir", modifiers: "text" },
    { name: "BBM", key: "BBM", modifiers: "text" },
    { name: "Keterangan", key: "KeteranganDetail", modifiers: "Text" },
  ];

  const modalHandler = (value, names) => {
    const newValues = { ...modalDetail, [names]: value };
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };
    setModalDetail(newValues);
  };

  const inputBuilder = [
    {
      type: "karyawan",
      name: "Nik",
      title: "Nik",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "JenisPetugas",
      name: "JenisPetugas",
      title: "Jenis Petugas",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "activity",
      name: "ActivityID",
      title: "Activity",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },

    {
      type: "SatuanKendaraan",
      name: "Satuan",
      title: "Satuan",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "text",
      name: "JamAwal",
      title: "Jam Awal",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "text",
      name: "JamAkhir",
      title: "Jam Akhir",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "KMHMAwal",
      title: "KMHM Awal",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "KMHMAkhir",
      title: "KMHM Akhir",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "BBM",
      title: "BBM",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "number",
      name: "HasilKerja",
      title: "Hasil Kerja",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "KeteranganDetail",
      title: "Keterangan",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
  ];

  const Kirim = () => {
    mutationUpdate.mutate({ TKendaraanID: params.id });
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate("/equipment/kendaraan")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  <button
                    onClick={() => Kirim()}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Approve"
                    )}
                  </button>
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <>
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"dateOnly"}
                      value={values}
                      name={"Tanggal"}
                      title={"Tanggal"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"GeneralServiceUnit"}
                      value={values}
                      name={"GeneralServiceUnit"}
                      title={"Kode Kenderaan"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                  {/*<div className="w-1/3">*/}
                  {/*    <HrdInputGenerator type={"Kendaraan"} value={values} name={"KendaraanID"}*/}
                  {/*                       title={"No. Plat"}*/}
                  {/*                       onChange={changeHandler} touched={touched}*/}
                  {/*                       buttonTouched={buttonTouched}*/}
                  {/*                       size={"full"}*/}
                  {/*                       required={true} errors={errors}*/}
                  {/*                       disabled={false}*/}
                  {/*    />*/}
                  {/*</div>*/}
                  <div className="w-1/3">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"Keterangan"}
                      title={"Keterangan"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                </>

                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  Master={false}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      id
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            type={type}
                            value={modalDetail}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                          />
                        );
                      }
                    }
                  )}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={() => {
                    if (!isValid && changed) {
                      setButtonTouched(true);
                    }
                    let tempIsValid = isValid;
                    if (!isValid) {
                    }
                    if (showModalEdit) {
                      let newValues = [...detail];
                      newValues[modalID] = modalDetail;
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                      setShowModalEdit(false);
                    } else {
                      const newValues = [...detail, modalDetail];
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                    }
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalKendaraanPage;
